<template>
  <div class="space-y-8 text-center">
    <div class="space-y-4">
      <h2 class="text-2xl font-bold text-base-content leading-tight">
        {{ $t("smartLeadForm.gdpr.title") }}
      </h2>
      <p class="text-base-content/70 leading-relaxed">
        {{ $t("smartLeadForm.gdpr.desc") }}
      </p>
    </div>

    <div class="space-y-3">
      <button class="btn btn-primary btn-lg w-full rounded-xl font-medium" @click="accept">
        {{ $t("smartLeadForm.gdpr.accept") }}
      </button>
      <button class="btn btn-ghost btn-sm text-base-content/50 hover:text-base-content/70" @click="decline">
        {{ $t("smartLeadForm.gdpr.decline") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

function accept() {
  emit("update:modelValue", {
    ...props.modelValue,
    subscribe: true,
  });
  emit("next");
}

function decline() {
  emit("update:modelValue", {
    ...props.modelValue,
    subscribe: false,
  });
  emit("next");
}
</script>
